import gql from 'graphql-tag';

const GET_POSITIONS = gql`
    query getPositionsDarkStore ($size: Int, $page: Int, $sort: SortInput, $filters: FilterInputPositionsProductData) {
        getPositionsDarkStore (size: $size, page: $page,  sort: $sort, filters: $filters) {
            internalCode
            totalRecords
            totalPage
            payload {
                id
                ean
                sectorPicking
                aisle
                aisleLabel
                place
                placeLabel
                position
                positionLabel
                tray
                trayLabel
                title
                sku
                numqr
                updatedat
            }
        }
    }
`;

export default GET_POSITIONS;
